import type { ProductProgressKey } from './productProgress';

export type ProductStatsKey = ProductProgressKey;

export interface ProductStats {
  downloads: number;
  rating: string;
  showDownloadsInApps: boolean;
}

export type ProductStatsMap = Record<ProductStatsKey, ProductStats>;

export const PRODUCT_STATS: ProductStatsMap = {
  'defter-kasa': {
    downloads: 0,
    rating: '0',
    showDownloadsInApps: true,
  },
  'kozmik-gunluk': {
    downloads: 0,
    rating: '0',
    showDownloadsInApps: true,
  },
  'anilar-muzesi': {
    downloads: 0,
    rating: '0',
    showDownloadsInApps: false,
  },
};

export const PRODUCT_STATS_KEYS = Object.keys(PRODUCT_STATS) as ProductStatsKey[];

export function clampDownloads(value: unknown): number {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return Math.max(0, Math.min(999_999_999, Math.round(numeric)));
}

export function normalizeRating(value: unknown): string {
  return String(value ?? '0').replace(/\s+/g, ' ').trim().slice(0, 16) || '0';
}

export function normalizeBoolean(value: unknown, fallback: boolean): boolean {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true') return true;
    if (normalized === 'false') return false;
  }
  return fallback;
}

export function formatDownloadCount(value: number): string {
  return `${clampDownloads(value).toLocaleString()}+`;
}
